export default class ErrorMSG {


    private _transId: string;
    private _from: string;
    private _subject: string;
    private _error: string;
    private _formData: string;
    private _timeStampStarted: string;
    private _timeStampEnded: string;
    private _email: string;
    private _mobile: string;
    private _name: string;


    constructor(transId: string, from: string, subject: string, error = '', formData = '',
        timeStampStarted = '', timeStampEnded = '', email = '', mobile = '', name = '') {
        this._transId = transId;
        this._from = from;
        this._subject = subject;
        this._error = error;
        this._formData = formData;
        this._timeStampStarted = timeStampStarted;
        this._timeStampEnded = timeStampEnded;
        this._email = email;
        this._mobile = mobile;
        this._name = name;
    }


    public get transId(): string {
        return this._transId;
    }

    public set transId(value: string) {
        this._transId = value;
    }

    public get from(): string {
        return this._from;
    }

    public set from(value: string) {
        this._from = value;
    }


    public get subject(): string {
        return this._subject;
    }

    public set subject(value: string) {
        this._subject = value;
    }

    public get error(): string {
        return this._error;
    }

    public set error(value: string) {
        this._error = value;
    }


    public get formData(): string {
        return this._formData;
    }

    public set formData(value: string) {
        this._formData = value;
    }

    public get timeStampStarted(): string {
        return this._timeStampStarted;
    }

    public set timeStampStarted(value: string) {
        this._timeStampStarted = value;
    }

    public get timeStampEnded(): string {
        return this._timeStampEnded;
    }

    public set timeStampEnded(value: string) {
        this._timeStampEnded = value;
    }

    public get email(): string {
        return this._email;
    }

    public set email(value: string) {
        this._email = value;
    }
    public get mobile(): string {
        return this._mobile;
    }
    public set mobile(value: string) {
        this._mobile = value;
    }
    public get name(): string {
        return this._name;
    }
    public set name(value: string) {
        this._name = value;
    }



}